import i18n from '../../../../../../../../../../i18n';
import { buildPanelGridCommonData } from '../buildPanelGridCommonData/buildPanelGridCommonData';

export const buildPanelGridApexDemoData = (
  sessionInfo: SessionInformation,
): PanelGridDataItem[] => {
  const { apexDemoMode, apexDemoName, apexDemoSubModeName } = sessionInfo;

  return [
    {
      key: 'apexDemoName',
      name: i18n.t('sessions.panels.info.sessionInformation.apexDemoName'),
      value: apexDemoName,
    },
    {
      key: 'apexDemoMode',
      name: i18n.t('sessions.panels.info.sessionInformation.apexDemoMode'),
      value: apexDemoMode,
    },
    {
      key: 'apexDemoSubModeName',
      name: i18n.t(
        'sessions.panels.info.sessionInformation.apexDemoSubModeName',
      ),
      value: apexDemoSubModeName,
    },
    ...buildPanelGridCommonData(sessionInfo),
  ];
};
